"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderMessageUnknownError = exports.renderChatUnknownError = exports.handleError = void 0;
var _types = require("./types");
var _chatActions = require("./chatActions");
var _modalActions = require("./modalActions");
var _exceptions = require("../exceptions");
var renderMessageUnknownError = exports.renderMessageUnknownError = function renderMessageUnknownError() {
  return {
    type: _types.MESSAGE_UNKNOWN_ERROR
  };
};
var renderChatUnknownError = exports.renderChatUnknownError = function renderChatUnknownError() {
  return {
    type: _types.CHAT_UNKNOWN_ERROR
  };
};

// ====================================================================
// Functions actions
// ====================================================================

var handleError = exports.handleError = function handleError(err) {
  return function (dispatch, _getState, _ref) {
    var Lurker = _ref.Lurker;
    var _err$name = err.name,
      name = _err$name === void 0 ? '' : _err$name,
      _err$callback = err.callback,
      callback = _err$callback === void 0 ? function () {} : _err$callback;
    var shouldLog = true;
    switch (name) {
      case 'SocketException':
        shouldLog = false;
        Lurker.viewConnectionError(err);
        break;
      case 'AuthException':
        shouldLog = false;
        dispatch((0, _chatActions.userNotLoggedChat)());
        break;
      case _exceptions.UserActionException.name:
        dispatch((0, _modalActions.openModal)(callback()));
        break;
      case _exceptions.CreateRoomException.name:
      case _exceptions.JoinRoomException.name:
      case _exceptions.LoadChatException.name:
        dispatch(renderMessageUnknownError());
        break;
      case _exceptions.LoadChatsException.name:
        dispatch(renderChatUnknownError());
        break;
      default:
        Lurker.unhandledError(err);
    }
    if (shouldLog) {
      console.log(err); // eslint-disable-line no-console
    }
  };
};